module.exports = __webpack_public_path__ + "img/ml3010.442fa6ef.png";